export const DATA_HOOKS = {
  root: 'ai-plan-recommendation-card',
  banner: 'ai-plan-recommendation-banner',
  bannerDummy: 'ai-plan-recommendation-banner-dummy',
  title: 'ai-recommendation-title',
  body: 'ai-recommendation-body',
  toggle: 'ai-recommendation-toggle',
} as const;
